import { InfoCircle } from '@assets/svgs';
import { JurisdictionOption } from '@models/brokerageOffering';
import { Item } from '@components/select/Select';
import { CollapsedField } from '@components/quoteDetails/CollapsedField';
import { QFCTypeExecuted } from '@components/quoteDetails/QuoteFieldControl';
import { AdditionalInfoLinkProps } from '@components/container/AdditionalInfoLink';
import { RadioButtonGroup } from '@components/radioButton/RadioButtonGroup';

export interface RadioButtonGroupFieldProps extends QFCTypeExecuted {
  getOptionValues: ({ isOverriding }: { isOverriding: boolean }) => Item[];
  onBlur: () => void;
  isRequired: boolean;
  isRequiredBeforeBind?: boolean;
  additionalInfoLink?: AdditionalInfoLinkProps;
}

export const RadioButtonGroupField = ({
  setValue,
  attributeType,
  filteredJurisdictions,
  errorMessage,
  value,
  isCollapsed,
  hoverText,
  isRequired,
  isRequiredBeforeBind,
  isReadOnly,
  getOptionValues,
  isOverriding,
  additionalInfoLink,
}: RadioButtonGroupFieldProps) => {
  let options = getOptionValues({ isOverriding });
  if (filteredJurisdictions && attributeType.codeName === 'StateCode') {
    const filteredAbbreviationList = filteredJurisdictions.map((el: JurisdictionOption) => el.abbreviation);
    options = options.filter((v) => filteredAbbreviationList.includes(v.value));
  }

  if (
    value !== undefined &&
    value !== null &&
    !options.find((v: { value: string; label: string }) => v.value == value)
  ) {
    const overrideOptions = getOptionValues({ isOverriding: true });

    const overrideOptionValueLabel =
      overrideOptions && overrideOptions?.find((v: { value: string; label: string }) => v.value == value)?.label;
    options.push({ value: value as string, label: `${overrideOptionValueLabel ?? value}`, hidden: true });
  }

  if (isCollapsed) {
    const selectedValue = options.find((option) => option.value == value);
    const label = value === null || value === undefined || value === '' ? undefined : selectedValue?.label;
    return <CollapsedField label={attributeType.label} value={label} deprecated={attributeType.deprecated} />;
  }

  return (
    <RadioButtonGroup
      items={options}
      value={value}
      label={attributeType.label}
      errorMessage={errorMessage}
      attributeType={attributeType}
      isRequired={isRequired}
      requiredBeforeBind={isRequiredBeforeBind}
      isReadOnly={isReadOnly}
      onChange={(value) => setValue(value)}
      disabled={isReadOnly}
      inputLabelIcon={hoverText ? <InfoCircle style={{ flexShrink: 0 }} /> : null}
      tooltipTitle={hoverText}
      additionalInfoLink={additionalInfoLink}
      deprecated={attributeType.deprecated}
    />
  );
};
